import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import XLSX from 'xlsx'
import { saveAs } from 'file-saver';
//utils
import queries from '../../utils/queries'

import HomeProg1 from './homeprog1';
import HomeProg2 from './homeprog2';

import CargProg1 from './prog/cargprog1';
import CargProg2 from './prog/cargprog2';
import ProgAddProg1 from './prog/progaddprog1';
import ProgAddProg2 from './prog/progaddprog2';
import ProgExcel1 from './prog/progexcel1';
import ProgExcel2 from './prog/progexcel2';
import ProgProyec1 from './prog/progproyec1';
import ProgProyec2 from './prog/progproyec2';
import ProgGenProg1 from './prog/proggenprog1';
import ProgGenProg2 from './prog/proggenprog2';
import ProgGenProgDia1 from './prog/proggenprogdia1';
import ProgGenProgDia2 from './prog/proggenprogdia2';
import ProgRepProg1 from './prog/progrepprog1';
import ProgRepProg2 from './prog/progrepprog2';
import ProgRepProgInd1 from './prog/progrepprogind1';
import ProgRepProgInd2 from './prog/progrepprogind2';
import ProgRepProgCerr1 from './prog/progrepprogcerr1';
import ProgRepProgCerr2 from './prog/progrepprogcerr2';
import VerProg1 from './prog/verprog1';
import VerProg2 from './prog/verprog2';
import VerProgRep1 from './prog/verprogrep1';
import VerProgRep2 from './prog/verprogrep2';
import ProgInfProg1 from './prog/proginfprog1';
import ProgInfProg2 from './prog/proginfprog2';
import ProgBuscProg1 from './prog/progbuscprog1';
import ProgBuscProg2 from './prog/progbuscprog2';
import VerOtHallazgo1 from './prog/verothallazgo1';
import VerOtHallazgo2 from './prog/verothallazgo2';
import ProgOtHallazgo1 from './prog/progothallazgo1';
import ProgOtHallazgo2 from './prog/progothallazgo2';
import AddOtHallazgo1 from './prog/addothallazgo1';
import AddOtHallazgo2 from './prog/addothallazgo2';
import ProgDepurar1 from './prog/progdepurar1';
import ProgDepurar2 from './prog/progdepurar2';
import ProgBitacoraNueva1 from './prog/progbitacoranueva1';
import ProgBitacoraNueva2 from './prog/progbitacoranueva2';
import ProgBitacoraTurno1 from './prog/progbitacoraturno1';
import ProgBitacoraTurno2 from './prog/progbitacoraturno2';
import ProgTableroProg1 from './prog/progtableroprog1';
import ProgTableroProg2 from './prog/progtableroprog2';
import ProgTableroBita1 from './prog/progtablerobita1';
import ProgTableroBita2 from './prog/progtablerobita2';
var moment = require('moment');

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

const styles ={
  modal:{
    width: '40%',
    top: '40%',
    left: '30%',
    position: 'fixed',
    color: 'blue'
  },
  bordes:{
    margin: '1em 0em 0.1em 0em',
    padding: '0em 0em 0em 0em',
  },
  menuPpal:{
    width: '25%',
    padding: '0.4em 0.2em 0em 2em',
  },
  boxIzq:{
    width: '25%',
    padding: '0.1em 0.2em 0em 1.2em',
  },
  boxDer:{
    width: '75%',
    padding: '0.1em 1.2em 0em 0.2em',
  },
  boxUnaCol:{
    width: '100%',
    padding: '1em 1em 2em 1em',
  },
  botones:{
    // background: 'linear-gradient(#093028, #237A57)',
    background: '#0B486B',
    margin: '0px 0px 0px 10px',
  },
  menu:{
    background: 'linear-gradient(#0F2027, #2C5364)',
    // background: 'linear-gradient(#FF0000, #dd1818)',
    // background: 'linear-gradient(#355C7D, #6C5B7B)',
  },
  divider:{
    margin: '10px 10px 10px 10px',
  },
  rowMarquee:{
    background: 'linear-gradient(#141E30, #243B55)',
    // background: '#0B486B',
    border: 'px solid blue',
    margin: '0px',
    padding: '2px 0 0 0',
    color: "white",
  },
  titBuscar:{
    // background: 'linear-gradient(#000000, #283c86)',
    background: 'linear-gradient(#272323, #283c86)',
    // background: 'linear-gradient(#355C7D, #6C5B7B)',
    height: '3em',
    color: 'white',
  },
  titBuscarTot:{
    fontSize: 16
  },
  etiqClientes:{
    padding: '12px 40px 12px 12px',
    color: "white",
  },
  dropdown:{
    // background: 'linear-gradient(#0F2027, #2C5364)',
    background: 'linear-gradient(#1C333D, #3C677A)',
    // background: 'linear-gradient(#141E30, #243B55)',
    // background: 'linear-gradient(#11998e, #38ef7d)',
    color: 'white',
    textAlign: 'left',
    width: '100%',
    fontWeight: 'normal',
  },
  listaDer:{
    background: 'linear-gradient(#1CB5E0, #000046)',
    margin: '0px',
    padding: '0px',
    height: '3em',
  },
  detCliente:{
    // background: 'linear-gradient(#1CB5E0, #000046)',
    background: 'linear-gradient(#1CB5E0, #000046)',
    margin: '0px',
    padding: '0px',
    height: '10em',
  },
  detalle:{
    margin: '0px',
    padding: '0px',
  },
  titClientes:{
    background: 'linear-gradient(#355C7D, #6C5B7B)',
    height: 'em',
  },
  box:{
    background: 'linear-gradient(#2a5298, #141E30)', border: '1px solid #2a5298',
    // bueno => background: '#243B55', border: '1px solid #141E30',
    // background: '#948E99', border: '1px solid #2E1437',
    // background: '#606c88',
    // background: 'white', border: '1px solid #e6e6e6',
    marginBottom: '1em',
    padding: '1em'
  },
  boxGrid:{
    width: '50%'
  },
  elemLis_1:{
    color: 'white',
    fontWeight: 'bold',
  },
  elemLis_2:{
    color: '#000000',
    // color: '#2C7744',
    fontWeight: 'bold',
  },
  elemLis_3:{
    color: '#93291E',
    fontWeight: 'bold',
  },
  subElemLis_1:{
    color: '#DCE35B',
    fontWeight: 'bold',
  },
  botIcon:{
    height: '1em',
    width: '1em',
  },
  chekBox:{
    padding: '0em 2em 0em 0em',
    // width: '1em',
  },
  label:{
    color: '#FEC500',
  },
  input:{
    background: 'linear-gradient(white, #999966 )',
    border: '0px',
    color: '#89253e',
    height: '2.9em'
  },
  confirmar:{
    background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
    border: '0px',
    color: '#135058',
    fontWeight: 'bold',
  },
  styTableSup:{
    margin: '0.2em',
    background: 'linear-gradient(#000046, #1CB5E0)',
    color: 'black',
  },
  styTableInf:{
    margin: '0.1em',
    background: 'linear-gradient(#1CB5E0, #000046)',
    color: 'yellow',
  },
  backGr_1:{
    // background: 'linear-gradient(#6dd5ed, #2193b0)',
    background: 'linear-gradient(#E9E4F0, #D3CCE3)',

  },
  backGr_2:{
    background: 'linear-gradient(#2193b0, #6dd5ed)',

  },
  styPaddMarg:{
    padding: '0.2em 0.1em 0.2em 0.1em',
    fontSize: '0.9em'
  },
  styInput:{
    width: '8em',
  },
  paraH1:{
    padding: '0em',
    margin: '0em',
    color: '#302b63',
  },
  paraH2_01:{
    padding: '0em',
    margin: '0em',
    color: '#2C7744',
  },
  paraH2_02:{
      padding: '0em',
      margin: '0em',
      color: '#FE0000',
  },
}

class HomeProg extends React.Component{
  state={
    showProg: true, showUpdProg: false, verProgramacion: false, verProgRep: false,
    showOtHallazgo: false, addOtHallazgo: false, verOtHallazgo: false,
    showExcel: false, showProyec: false, showGenProg: false, showGenProgDia: false, ruta: 0, 
    showRepProg: false, showRepProgInd: false, showRepProgCerr: false, showAddProg: false, showInfProg: false, showBuscProg: false, showDepurar: false, 
    showBitacora: false, showBitacoraTurno: false, showTableroProg: false, showTableroBita: false, pruebaLAdd: [], opcion: "",
    permiteUpdate: false, permiteDelete: false,
    permiteClose: false, argsAdd: {}, errorAdd: [], argsBuscar: {}, argsBuscInf: {},
    argsBuscProg: {descrEmpresa: ""},
    idLista: {},
    argsQuery: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo', codComponente: '$secciones.equipos.componentes.codComponente',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
        descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
        categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub',
        tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
        tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
        descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado',
        descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
        tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
        abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
        cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
        descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
        abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad'}}`,
    argsQuery1: `{"$unwind": "$secciones"},
    {"$unwind": "$secciones.equipos"},
    {"$unwind": "$secciones.equipos.componentes"},
    {"$unwind": "$secciones.equipos.componentes.mecanismos"},
    {$project: {_id: 1, programacion: {
        $let: {
          vars: {regProg: { $cond: { if: { $isArray: "$secciones.equipos.componentes.mecanismos.programacion" },
                                        then: { $size: "$secciones.equipos.componentes.mecanismos.programacion" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regProg", 0 ] },
                              then: "$secciones.equipos.componentes.mecanismos.programacion",
                              else: [{consecutivo: null, cantidad: null, puntosLub: null, minutos: null, descrMetodo: null,
                                  descrTarea: null, modoTarea: null, requiereSISO: null, descrFrecuencia: null, descrFrecuenciaPre: null, codProcedimiento: null, nombreArchivo: null,
                                  codInfoTarea: null, nombreArchivoInfo: null, fechaUlt: null, fechaProx: null, acumProx: 0, enRuta: null, activo: null}] } }
        }
      },
      descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
      descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
      descrEquipo: '$secciones.equipos.descrEquipo', acumulado: '$secciones.equipos.acumulado', numCarta: '$secciones.equipos.numCarta', 
      codComponente: '$secciones.equipos.componentes.codComponente',
      descrComponente: '$secciones.equipos.componentes.descrComponente',
      codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
      descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
      descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
      tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
      descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
      descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
      tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
      tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
      tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
      abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
      cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
      descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
      abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad'}},
    {"$unwind": "$programacion"},
    {$project: {_id: {$concat: ['$descrEmpresa', '$descrPlanta', '$descrSeccion', '$descrEquipo', '$descrComponente', '$descrMecanismo', '$programacion.descrTarea']}, descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: 1, descrSeccion: 1, codEquipo: 1,
      descrEquipo: 1, acumulado: 1, numCarta: 1, codComponente: 1, descrComponente: 1, codMecanismo: 1, descrMecanismo: 1, descrAplicacion: 1,
      tipoLub: 1, descrFabricante: 1, descrLubricante: 1, tipoFrecuencia: 1, tipoLub: 1, tipoGrado: 1, abrevUnidadTF: 1,
      cantidadTotal: 1, descrUnidad: 1, abrevUnidad: 1,
      consecutivo: '$programacion.consecutivo', cantidad: '$programacion.cantidad',
      puntosLub: '$programacion.puntosLub', minutos: '$programacion.minutos', descrMetodo: '$programacion.descrMetodo', descrTarea: '$programacion.descrTarea',
      modoTarea: '$programacion.modoTarea', requiereSISO: '$programacion.requiereSISO', descrFrecuencia: '$programacion.descrFrecuencia', descrFrecuenciaPre: '$programacion.descrFrecuenciaPre',
      codProcedimiento: '$programacion.codProcedimiento', nombreArchivo: '$programacion.nombreArchivo', fechaUlt: '$programacion.fechaUlt', 
      codInfoTarea: '$programacion.codInfoTarea', nombreArchivoInfo: '$programacion.nombreArchivoInfo', 
      fechaProx: '$programacion.fechaProx', acumProx: '$programacion.acumProx', enRuta: '$programacion.enRuta', 
      activo: '$programacion.activo', 
      anchoImagen: {
        $let: {
          vars: {fechaProxDif: '$programacion.fechaProx'},
         in: {$cond: [
           {
             "$or":[
              { "$eq": [ "$$fechaProxDif", null ] },
              { "$eq": [ "$$fechaProxDif", '' ]},
             ]
           }, 
           1,
           { $toInt: {$divide: [{$subtract: [ new Date(), {"$toDate": '$$fechaProxDif'} ]}, 86400000 ]}}
          ]
        }}
      },
      ultInforme: {
        $let: {
          vars: {acumProxDif: { $subtract: [ "$acumulado", "$acumProx" ]}},
          in: {$cond: [
            {
              "$or":[
               { "$eq": [ "$$acumProxDif", null ] },
               { "$eq": [ "$$acumProxDif", '' ]},
              ]
            }, 
            1,
            { $toInt: {$divide: ["$$acumProxDif", 1 ]}}
           ]
         }
        }
      }
    }}`  
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

    crudBD = async (operacionCRUD, args, i)=>{
      if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
          variables: args
        });

//Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          await operacionCRUD({
            variables: args
          });
        }
      }
    }
      
    updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
  //ENVIO PARA ACTUALIZAR BD
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      for(let i=1; i<totDocCRUD; i++){
        await this.crudBD(crudColecc[i], argsCrud[i], i)
      }
    }

    handleChangeBuscEstruct = (ev)=>{
      // console.log(ev.target.name)
      // console.log(ev.target.value)
      const argsBuscProg = this.state.argsBuscProg
        if(ev.target.name==="descrPlantaB"){
          argsBuscProg["descrPlanta"] = ev.target.value
        }else{
          if(ev.target.name==="descrSeccionB"){
            argsBuscProg["descrSeccion"] = ev.target.value
          }else{
            if(ev.target.name==="descrEquipoB"){
              argsBuscProg["descrEquipo"] = ev.target.value
            }else{
              if(ev.target.name==="descrComponenteB"){
                argsBuscProg["descrComponente"] = ev.target.value
              }else{
                if(ev.target.name==="descrMecanismoB"){
                  argsBuscProg["descrMecanismo"] = ev.target.value
                }else{
                  if(ev.target.name==="descrFrecuenciaB"){
                    argsBuscProg["descrFrecuencia"] = ev.target.value
                  }else{
                    if(ev.target.name==="descrTareaB"){
                      argsBuscProg["descrTarea"] = ev.target.value
                    }else{
                      if(ev.target.name==="descrProgramaB"){
                        argsBuscProg["descrPrograma"] = ev.target.value
                      }else{
                        if(ev.target.name==="rutaB"){
                          argsBuscProg["ruta"] = ev.target.value
                        }else{
                          argsBuscProg[ev.target.name] = ev.target.value
                        }
                      }
                    }
                  }
                }            
              }
            }
          }
        }
        // argsBuscProg[ev.target.name] = ev.target.value
      // console.log(argsBuscProg)
      this.setState({argsBuscProg});
      this.handleBuscEstruct(argsBuscProg)
    }
  
    handleBuscEstruct = async (argsBuscProg) => { 
      let argsBuscar={}
      // console.log(this.state.argsBuscProg)
      // if(argsBuscEstr.descrEmpresa){
      //   argsBuscProg = argsBuscEstr
      // }else{
        // let argsBuscProg = this.state.argsBuscProg
      // }
      argsBuscar.descrEmpresa=argsBuscProg.descrEmpresa
      if(argsBuscProg.numDocum){
        argsBuscar.numDocum=parseInt(argsBuscProg.numDocum, 10)
      }else{
        // argsBuscar.numDocum=100
      }
      if(argsBuscProg.descrPlanta){
        argsBuscar.descrPlanta=argsBuscProg.descrPlanta
      }else{
        delete argsBuscar.descrPlanta
      }
      if(argsBuscProg.descrSeccion){
        argsBuscar.descrSeccion=argsBuscProg.descrSeccion
      }else{
        delete argsBuscar.descrSeccion
      }
      if(argsBuscProg.descrEquipo){
        argsBuscar.descrEquipo=argsBuscProg.descrEquipo
      }else{
        delete argsBuscar.descrEquipo
      }
      if(argsBuscProg.descrComponente){
        argsBuscar.descrComponente=argsBuscProg.descrComponente
      }else{
        delete argsBuscar.descrComponente
      }
      if(argsBuscProg.descrMecanismo){
        argsBuscar.descrMecanismo=argsBuscProg.descrMecanismo
      }else{
        delete argsBuscar.descrMecanismo
      }
      if(argsBuscProg.descrFrecuencia){
        argsBuscar.descrFrecuencia=argsBuscProg.descrFrecuencia
      }else{
        delete argsBuscar.descrFrecuencia
      }
      if(argsBuscProg.estadoOrden){
        argsBuscar.estadoOrden=argsBuscProg.estadoOrden
      }else{
        delete argsBuscar.estadoOrden
      } 
      if(argsBuscProg.descrTarea){
        argsBuscar.descrTarea=argsBuscProg.descrTarea
      }else{
        delete argsBuscar.descrFrecuencia
      }
      if(argsBuscProg.descrPrograma){
        argsBuscar.descrPrograma=argsBuscProg.descrPrograma
      }else{
        delete argsBuscar.descrPrograma
      }
      if(argsBuscProg.alimSistema){
        argsBuscar.alimSistema=argsBuscProg.alimSistema
      }else{
        delete argsBuscar.alimSistema
      }   
      if(argsBuscProg.ruta){
        argsBuscar.ruta=argsBuscProg.ruta
      }else{
        delete argsBuscar.ruta
      }

      this.setState({argsBuscProg: argsBuscar});
    }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }
  showUpdProg = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showUpdProg: true})
  }
  showAddProg = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showAddProg: true})
  }
  showProg = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProg: true})
  }
  showOtHallazgo = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showOtHallazgo: true})
  }
  addOtHallazgo = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addOtHallazgo: true})
  }
  showExcel = (ev, opcion) => { 
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showExcel: true, opcion})
  }
  showProyec = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProyec: true, opcion})
  }
  showGenProg = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showGenProg: true, opcion})
  }
  showGenProgDia = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showGenProgDia: true, opcion})
  }
  showRepProg = (ev, ruta) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRepProg: true, ruta})
  }
  showRepProgInd = (ev, opcion) => {
    ev.preventDefault()
    this.props.allOrdenRtes1.refetch()
    this.estadosFalse()
    this.setState({showRepProgInd: true, opcion})
  }
  showRepProgCerr = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRepProgCerr: true, opcion})
  }
  showInfProg = (ev, opcion) => {
    ev.preventDefault()
    // this.props.allPlantaRtes.refetch()
    this.estadosFalse()
    this.setState({showInfProg: true, opcion})
  }
  showDepurar = (ev, opcion) => {
    ev.preventDefault()
    // this.props.allPlantaRtes.refetch()
    this.estadosFalse()
    this.setState({showDepurar: true, opcion})
  }
  showBitacora = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showBitacora: true, opcion})
  }
  showBitacoraTurno = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showBitacoraTurno: true, opcion})
  }

  showBuscProg = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showBuscProg: true})
  }

  showTableroProg = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showTableroProg: true})
  }
  showTableroBita = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showTableroBita: true})
  }

  idLista = async (ev, idLista, ruta)=>{
    this.setState({idLista: idLista})
console.log(idLista)
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showProg) {
      this.setState({verProgramacion: true})
    }
    if (this.state.showOtHallazgo) {
      this.setState({verOtHallazgo: true})
    }
    if (this.state.showRepProgInd) {
      this.setState({verProgRep: true, ruta})
    }
  };

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd

    let datoTipo = ""
    if(input!==undefined&&ev.target.name===undefined){
      datoTipo = input.type
    } 

    if(datoTipo==='checkbox'){
      if (this.state.addEstructura) {
        argsAdd[input.name] = input.label
      }else{
        argsAdd[input.name] = input.checked
      }
    }else{
      if(ev.target.type==='checkbox'){
        argsAdd[ev.target.name] = ev.target.checked
      }else{
        argsAdd[ev.target.name] = ev.target.value
      }
    }
    this.setState({argsAdd});
    // console.log(argsAdd)
  }

  handleChangeBuscProg = (ev)=>{
    const argsBuscProg = this.state.argsBuscProg
    if(ev.target.name === "numDocum"){
      var numDocum = document.getElementById("numDocum");
      if(ev.target.value<=0){
        numDocum.value = ""
        argsBuscProg[ev.target.name] = ""
      }else{
        argsBuscProg[ev.target.name] = ev.target.value
      }
    }else{
      if(ev.target.name==="descrEmpresaB" || ev.target.name==="descrEmpresa"){
        argsBuscProg["descrEmpresa"] = ev.target.value
      }else{
        if(ev.target.name==="descrPlantaB" || ev.target.name==="descrPlanta"){
          argsBuscProg["descrPlanta"] = ev.target.value
        }else{
          if(ev.target.name==="descrSeccionB" || ev.target.name==="descrSeccion"){
            argsBuscProg["descrSeccion"] = ev.target.value
          }else{
            if(ev.target.name==="descrEquipoB" || ev.target.name==="descrEquipo"){
              argsBuscProg["descrEquipo"] = ev.target.value
            }else{
              if(ev.target.name==="descrComponenteB" || ev.target.name==="descrComponente"){
                argsBuscProg["descrComponente"] = ev.target.value
              }else{
                if(ev.target.name==="descrMecanismoB" || ev.target.name==="descrMecanismo"){
                  argsBuscProg["descrMecanismo"] = ev.target.value
                }else{
                  if(ev.target.name==="estadoOrdenB" || ev.target.name==="estadoOrden"){
                    argsBuscProg["estadoOrden"] = ev.target.value
                  }else{
                    if(ev.target.name==="estado" || ev.target.name==="estado"){
                      argsBuscProg["estado"] = ev.target.value
                    }else{
                      if(ev.target.name==="rutaB" || ev.target.name==="ruta"){
                        argsBuscProg["ruta"] = ev.target.value
                      }else{
                        if(ev.target.name==="numeroOrdenB" || ev.target.name==="numeroOrden"){
                          argsBuscProg["numeroOrden"] = ev.target.value
                        }else{
                          if(ev.target.name==="realizadoB" || ev.target.name==="realizado"){
                            argsBuscProg["realizado"] = ev.target.value
                          }else{
                            if(ev.target.name==="descrMetodoB" || ev.target.name==="descrMetodo"){
                              argsBuscProg["descrMetodo"] = ev.target.value
                            }else{
                              if(ev.target.name==="alimSistemaB" || ev.target.name==="alimSistema"){
                                argsBuscProg["alimSistema"] = ev.target.value
                              }else{
                                argsBuscProg[ev.target.name] = ev.target.value
                              }
                            }
                          }
                        }
                      }
                    }
                  }                 
                }            
              }
            }
          }
        }
      }
      // argsBuscProg[ev.target.name] = ev.target.value
    }
    console.log(argsBuscProg)
    this.setState({argsBuscProg});
    this.handleBuscProg(argsBuscProg)
  }


  handleBuscProg = async (argsBuscProg) => {
    let argsBuscar={}

    // argsBuscar.descrEmpresa=argsBuscProg.descrEmpresa
    if(argsBuscProg.numDocum){
      argsBuscar.numDocum=parseInt(argsBuscProg.numDocum, 10)
    }else{
      // argsBuscar.numDocum=100
    }
    if(argsBuscProg.descrEmpresa){
      argsBuscar.descrEmpresa=argsBuscProg.descrEmpresa
    }else{
      delete argsBuscar.descrEmpresa
    }
    if(argsBuscProg.descrPlanta){
      argsBuscar.descrPlanta=argsBuscProg.descrPlanta
    }else{
      delete argsBuscar.descrPlanta
    }
    if(argsBuscProg.descrSeccion){
      argsBuscar.descrSeccion=argsBuscProg.descrSeccion
    }else{
      delete argsBuscar.descrSeccion
    }
    if(argsBuscProg.descrEquipo){
      argsBuscar.descrEquipo=argsBuscProg.descrEquipo
    }else{
      delete argsBuscar.descrEquipo
    }
    if(argsBuscProg.descrComponente){
      argsBuscar.descrComponente=argsBuscProg.descrComponente
    }else{
      delete argsBuscar.descrComponente
    }
    if(argsBuscProg.descrMecanismo){
      argsBuscar.descrMecanismo=argsBuscProg.descrMecanismo
    }else{
      delete argsBuscar.descrMecanismo
    }
    if(argsBuscProg.estadoOrden){
      argsBuscar.estadoOrden=argsBuscProg.estadoOrden
    }else{
      delete argsBuscar.estadoOrden
    }
    if(argsBuscProg.estado){
      argsBuscar.estado=argsBuscProg.estado
    }else{
      delete argsBuscar.estado
    }
    if(argsBuscProg.descrTarea){
      argsBuscar.descrTarea=argsBuscProg.descrTarea
    }else{
      delete argsBuscar.descrTarea
    }
    if(argsBuscProg.descrMetodo){
      argsBuscar.descrMetodo=argsBuscProg.descrMetodo
    }else{
      delete argsBuscar.descrMetodo
    }
    if(argsBuscProg.descrPrograma){
      argsBuscar.descrPrograma=argsBuscProg.descrPrograma
    }else{
      delete argsBuscar.descrPrograma
    }
    if(argsBuscProg.ruta){
      argsBuscar.ruta=argsBuscProg.ruta
    }else{
      delete argsBuscar.ruta
    }
    if(argsBuscProg.numeroOrden){
      argsBuscar.numeroOrden=argsBuscProg.numeroOrden
    }else{
      delete argsBuscar.numeroOrden
    }
    if(argsBuscProg.realizado){
      argsBuscar.realizado=argsBuscProg.realizado
    }else{
      delete argsBuscar.realizado
    }
    if(argsBuscProg.alimSistema){
      argsBuscar.alimSistema=argsBuscProg.alimSistema
    }else{
      delete argsBuscar.alimSistema
    } 
    console.log(argsBuscar)
    this.setState({argsBuscProg: argsBuscar});

    //VALIDAR SI MODIFICARON EL localStorage userLogin o Empresa
    const argsEncr = {
      valor: localStorage.getItem('userLogin'),
      comparar: localStorage.getItem('token1')
    }
    const response = await this.props.encriptar({
      variables: argsEncr
    });
    const {success} = response.data.encriptar;
    let enapp = success
    if(enapp){
      const argsEncr = {
        valor: localStorage.getItem('Empresa'),
        comparar: localStorage.getItem('token2')
      }
      const response = await this.props.encriptar({
        variables: argsEncr
      });
      const {success} = response.data.encriptar;
      enapp = success  
    }
    if (!enapp){
//MODIFICARON EL localStorage userLogin o Empresa
      localStorage.removeItem('token');
      localStorage.removeItem('token1');
      localStorage.removeItem('token2');
      localStorage.removeItem('Empresa');
      localStorage.removeItem('userLogin');
console.log("ojo")
      this.props.history.push("/")
    }
  }


  handleUpdAsImgOT = async (ev, idLista, Img)=>{
    let listImg = ev.target.files
console.log(listImg)
    if(listImg.length===1){
      if(idLista.numeroOrden){
        document.body.style.cursor = 'wait'

        let movColecc = []
        let argsUpd = {}
        
        if(Img==='A'){
           argsUpd = {
            "tipoAct": 'EditarImgAntes',
            "imgAntes": ev.target.files[0].name,
            "numeroOrden": idLista.numeroOrden,
            "ruta": idLista.ruta
          }
          if(!ev.target.files[0]){
            argsUpd['file'] = "";
          }else{
            argsUpd['file'] = ev.target.files[0];
            let response = await this.props.singleUpload({variables: {file: ev.target.files[0]}}); 
          }
        }
        if(Img==='D'){
          argsUpd = {
            "tipoAct": 'EditarImgDespues',
            "imgDespues": listImg[0].name,
            "numeroOrden": idLista.numeroOrden,
            "ruta": idLista.ruta
          }
          if(!ev.target.files[0]){
            argsUpd['file'] = "";
          }else{
            argsUpd['file'] = ev.target.files[0];
            let response = await this.props.singleUpload({variables: {file: ev.target.files[0]}}); 
          } 
        }
        if(Img==='VA'){
          argsUpd = {
           "tipoAct": 'EditarVideoAntes',
           "videoAntes": ev.target.files[0].name,
           "numeroOrden": idLista.numeroOrden,
           "ruta": idLista.ruta
         }
         if(!ev.target.files[0]){
           argsUpd['file'] = "";
         }else{
           argsUpd['file'] = ev.target.files[0];
           let response = await this.props.singleUpload({variables: {file: ev.target.files[0]}}); 
         }
       }
       if(Img==='VD'){
         argsUpd = {
           "tipoAct": 'EditarVideoDespues',
           "videoDespues": listImg[0].name,
           "numeroOrden": idLista.numeroOrden,
           "ruta": idLista.ruta
         }
         if(!ev.target.files[0]){
           argsUpd['file'] = "";
         }else{
           argsUpd['file'] = ev.target.files[0];
           let response = await this.props.singleUpload({variables: {file: ev.target.files[0]}}); 
         } 
       }
       if(Img==='R'){
        argsUpd = {
          "tipoAct": 'EditarRCA',
          "archivoRCA": listImg[0].name,
          "numeroOrden": idLista.numeroOrden,
          "ruta": idLista.ruta
        }
        if(!ev.target.files[0]){
          argsUpd['file'] = "";
        }else{
          argsUpd['file'] = ev.target.files[0];
          let response = await this.props.singleUpload({variables: {file: ev.target.files[0]}}); 
        } 
      }
        
        console.log(argsUpd)  
        let response = await this.props.editOrden({
          variables: argsUpd
        });
        const {errors, success} = response.data.editOrden;
           
//         movColecc.push(argsUpd)

//         let numDocCRUD = 0
//         let totDocCRUD = 1
//         let argsCrud = []
//         let crudColecc = []
//         for(let iii=0; iii<totDocCRUD; iii++){
//           argsCrud.push({ctrlCampo: 'NO_CRUD'})
//         }
//         for(let iii=0; iii<totDocCRUD; iii++){
//           crudColecc.push(this.props.editOrden)
//         }

//         argsCrud[numDocCRUD] = movColecc[0]
//         argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
//         argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
//         crudColecc[numDocCRUD] = this.props.editOrden
//         await this.updColecc(crudColecc, argsCrud, totDocCRUD)

        document.body.style.cursor = 'default'
        alert("!! Archivo cargado !!")
        const argsBuscProg = this.state.argsBuscProg
        this.setState({argsBuscProg});
        // this.handleBuscCoti(argsBuscProg)
  
        if (this.state.showOtHallazgo) {
          this.props.allOrdenRtes.refetch()
        }
      }else{
        alert("!! Por favor seleccione la orden !!")
        // document.getElementById("img").value = ""
      }
    }else{
      console.log(listImg[0].length)
      alert("!! Solo le puede asociar una imagen de antes y después a cada orden !!")
    }
  }

  handleSeltipoVista = () => {
    var miLista1 = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['miLista1'] = miLista1.options[miLista1.selectedIndex].text
    this.setState({argsAdd});
  }

  handleGenProg = async (ev, args)=>{
    let idPruebaSel = args._id

    let argsUpd=args

    argsUpd.tipoAct='EditarCargue'
      const response = await this.props.editOrdenes({
          variables: argsUpd
      });
      const {errors, success} = response.data.editOrdenes;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.estadosFalse()
        this.setState({showGenProg: true})
      }
    // }
  }

  handleGenProgDia = async (ev, args)=>{
    let idPruebaSel = args._id

    let argsUpd=args

    argsUpd.tipoAct='EditarCargue'
      const response = await this.props.editOrdenes({
          variables: argsUpd
      });
      const {errors, success} = response.data.editOrdenes;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.estadosFalse()
        this.setState({showGenProgDia: true})
      }
    // }
  }

  showDescProg = async () => { 
    let argsBuscar=""
    argsBuscar += `'descrEmpresa': '${this.state.argsBuscProg.descrEmpresa}'`
    if(this.state.argsBuscProg.descrPlanta){
      argsBuscar += `, 'descrPlanta': /${this.state.argsBuscProg.descrPlanta}/i`
    }
    if(this.state.argsBuscProg.descrSeccion){
      argsBuscar += `, 'descrSeccion': /${this.state.argsBuscProg.descrSeccion}/i`
    }
    if(this.state.argsBuscProg.descrEquipo){
      argsBuscar += `, 'descrEquipo': /${this.state.argsBuscProg.descrEquipo}/i`
    }
    if(this.state.argsBuscProg.descrComponente){
      argsBuscar += `, 'descrComponente': /${this.state.argsBuscProg.descrComponente}/i`
    }
    if(this.state.argsBuscProg.descrMecanismo){
      argsBuscar += `, 'descrMecanismo': /${this.state.argsBuscProg.descrMecanismo}/i`
    }
    if(this.state.argsBuscProg.estado){
      if(this.state.argsBuscProg.estado==='VIGENTE'){
        argsBuscar += `, 'anchoImagen': {$lt: 0}`
      }
      if(this.state.argsBuscProg.estado==='PROGRAMADO'){
        argsBuscar += `, 'enRuta': 'S', 'anchoImagen': {$gte: 0}`
      }
      if(this.state.argsBuscProg.estado==='VENCIDO'){
        argsBuscar += `, 'enRuta': 'N', 'anchoImagen': {$gte: 0}`
      }      
    }
    let argsBuscarPl = {}
    argsBuscarPl = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}, {$sort: {numCarta: 1, consecutivo: 1}}]`}
  
    // console.log(argsBuscarPl)
    let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
    let estructura = await data.allPlantaRtes
    // console.log(estructura)
  
    if(estructura.length>0){
  //Archivo Excel
      let xlsString = []
      let listRtes = estructura
  // console.log(listRtes)
      let xlsString1 = []
      xlsString1 = ['Consecutivo', 'Empresa', 'Planta', 'Sección', 'Equipo', '# Carta de equipo', 'Componente', 'Mecanismo', 
        'Aplicación/Espesante', 'Tipo de lubricante', 'Nombre del lubricante', 'Cant. lub. Tarea', 'Unidad', 'Min. ejec. tarea', 
        'Método', 'Tarea', 'Nuevo Método', 'Nueva Tarea', 'Modo ejec, tarea', 'Requiere SISO', 'Puntos a lub.', 'Frecuencia', 'Frecuencia Predictiva', 'Fecha última ejec.',
        'Año prox. ejec.', 'Mes prox. ejec.', 'Día prox. ejec.', 'Acum. prox.', 'Codigo del Procedimiento', 'Código advertencia de tarea', 'Activo para LCM (S/N)'
      ]
      xlsString.push(xlsString1)
      let empresa = ''
  
      for(let i=0; i<listRtes.length; i++){
        let campoAgno = ''
        let campoMes = ''
        let campoDia= ''
        if(listRtes[i].fechaProx!==null && listRtes[i].fechaProx!==''){
          campoAgno = listRtes[i].fechaProx.substring(0, 4)
          campoMes = listRtes[i].fechaProx.substring(5, 7)
          campoDia = listRtes[i].fechaProx.substring(8, 10)
        } 
        let fechaUlt=''
        if(listRtes[i].fechaUlt!==null && listRtes[i].fechaUlt!==''){
          fechaUlt = listRtes[i].fechaUlt.substr(0, 10)
        }    
        let consec = listRtes[i].consecutivo?parseInt(listRtes[i].consecutivo, 10):0  
        xlsString1 = [consec, listRtes[i].descrEmpresa, listRtes[i].descrPlanta,
        listRtes[i].descrSeccion, listRtes[i].descrEquipo, listRtes[i].numCarta?listRtes[i].numCarta:0, 
        listRtes[i].descrComponente, listRtes[i].descrMecanismo, 
        listRtes[i].descrAplicacion, listRtes[i].tipoLub, listRtes[i].descrLubricante,
        listRtes[i].cantidad?listRtes[i].cantidad:0, listRtes[i].abrevUnidad, 
        listRtes[i].minutos?listRtes[i].minutos:0, listRtes[i].descrMetodo, listRtes[i].descrTarea, listRtes[i].descrMetodo, listRtes[i].descrTarea, 
        listRtes[i].modoTarea?listRtes[i].modoTarea:'O', listRtes[i].requiereSISO?listRtes[i].requiereSISO:'No', listRtes[i].puntosLub?listRtes[i].puntosLub:0,
        listRtes[i].descrFrecuencia, listRtes[i].descrFrecuenciaPre, fechaUlt, campoAgno, campoMes, campoDia,
        listRtes[i].acumProx?listRtes[i].acumProx:0, listRtes[i].codProcedimiento!=='Seleccionar...'?listRtes[i].codProcedimiento:'', 
        listRtes[i].codInfoTarea!=='Seleccionar...'?listRtes[i].codInfoTarea:'', listRtes[i].activo?listRtes[i].activo:'S']
  
  // console.log(xlsString1)
        xlsString.push(xlsString1)
        empresa = listRtes[i].descrEmpresa
      }
  // console.log(xlsString)
  
      var wb = XLSX.utils.book_new();
  
      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };
  
      wb.SheetNames.push("Programacion");
  
      let ws_data = xlsString;
  
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Programacion"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), empresa + '_programacion.xlsx');
    }
  }

handleProg = async (ev, args, descrMetodoAnt, descrTareaAnt)=>{
  if((!args.descrMetodo||!args.descrTarea||!args.descrFrecuencia)&&!this.state.permiteDelete){
    const argsAdd = this.state.argsAdd
    const errors = [];
    if(!args.descrMetodo){
      errors.push({path: 'descrMetodo', message: "Debe seleccionar el método"});
    }
    if(!args.descrTarea){
      errors.push({path: 'descrTarea', message: "Debe seleccionar la tarea"});
    }
    if(!args.descrFrecuencia){
      errors.push({path: 'descrFrecuencia', message: "Debe seleccionar la frecuencia"});
    }else{
      if(!args.descrFrecuenciaPre){
        errors.push({path: 'descrFrecuenciaPre', message: "Debe seleccionar la frecuencia predictiva"});
      }
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }else{
    if(this.state.addEstructura){

    }else{
      if(this.state.permiteUpdate){
        var miLista = document.getElementById("miLista1");
        var miLista2 = document.getElementById("miLista2");
        var miLista3 = document.getElementById("miLista3");
        var miLista4 = document.getElementById("miLista4");
        let nombreArchivo='', nombreArchivoInfo=''
        let allProcEjec = this.props.allProcEjec.allProcEjec
        let allInfoTarea = this.props.allProcEjec.allInfoTarea

        if(args.codProcedimiento){
          let indexProc = allProcEjec.findIndex( procejec => procejec.codProcedimiento==args.codProcedimiento) 
          if(indexProc!==-1){
            nombreArchivo = allProcEjec[indexProc].nombreArchivo
          } 
        }
        if(args.codInfoTarea){
          let indexInfo = allInfoTarea.findIndex( infotarea => infotarea.codInfoTarea==args.codInfoTarea) 
          if(indexInfo!==-1){
            nombreArchivoInfo = allInfoTarea[indexInfo].nombreArchivoInfo
          } 
        }
        let fechaProx=''
        let acumProx=0
        if(args.fechaProx){
          fechaProx=args.fechaProx
        }
        if(args.acumProx){
          acumProx=parseInt(args.acumProx)
        }        
        const argsUpd = {
          descrEmpresa: args.descrEmpresa,
          descrPlanta: args.descrPlanta,
          descrSeccion: args.descrSeccion,
          descrEquipo: args.descrEquipo,
          descrComponente: args.descrComponente,
          descrMecanismo: args.descrMecanismo,
          descrMetodo: args.descrMetodo,
          descrTarea: args.descrTarea,
          descrFrecuencia: args.descrFrecuencia,
          descrFrecuenciaPre: args.descrFrecuenciaPre?args.descrFrecuenciaPre:'',
          codProcedimiento: args.codProcedimiento?args.codProcedimiento:'',
          nombreArchivo: nombreArchivo,
          codInfoTarea: args.codInfoTarea?args.codInfoTarea:'',
          nombreArchivoInfo: nombreArchivoInfo,
          cantidad: args.cantidad?args.cantidad:0,
          minutos: args.minutos?args.minutos:0,
          puntosLub: args.puntosLub?args.puntosLub:0,
          activo: args.activo?args.activo:'S',
          fechaProx: fechaProx,
          acumProx: acumProx,
          descrMetodoAnt: descrMetodoAnt,
          descrTareaAnt: descrTareaAnt
        }
        if(this.state.permiteUpdate){
          argsUpd.tipoAct = "EditarProgramacion"
          let response = await this.props.editPlantaUpdSeccion({variables: argsUpd});
        }
        this.estadosFalse()
        this.setState({showProg: true})
      }
      if(this.state.permiteDelete){
        const argsUpd = {
          _id: args._id,
          descrEmpresa: args.descrEmpresa,
          descrPlanta: args.descrPlanta,
          descrSeccion: args.descrSeccion,
          descrEquipo: args.descrEquipo,
          descrComponente: args.descrComponente,
          descrMecanismo: args.descrMecanismo,
          descrMetodo: descrMetodoAnt,
          descrTarea: descrTareaAnt,          
          tipoAct: "EliminarProgramacion"
        }
        console.log(argsUpd)
        let response = await this.props.editPlantaUpdSeccion({variables: argsUpd});
        this.estadosFalse()
        this.setState({showProg: true})
      }
    }
  }
}

handleProgRep = async (ev, args)=>{
  if(args.realizado==='Seleccionar...' && !this.state.permiteDelete){
    const errors = [];
    errors.push({path: 'realizado', message: "Debe seleccionar Si o No en Tarea ejecutada"});
    this.setState({errorAdd: errors})
  }else{
    let argsUpd = {}
    let fechaReal = moment()
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      fechaReal = moment(fechaHoraHoy).format('YYYY-MM-DD')
    let fechaHoy = new Date()
    let horaReal = fechaHoy.getHours()
    argsUpd.fechaReal=fechaReal
    argsUpd.horaReal=horaReal
    let allUsuarios = this.props.allUsuarios.allUsuarios
    let nombreUsuarioReal = '', cedulaReal='', realizado=''
    let indexUsu = allUsuarios.findIndex( usuario => usuario.email===localStorage.getItem('userLogin') )
    if(indexUsu!==-1){
      nombreUsuarioReal=allUsuarios[indexUsu].nombreUsuario
      cedulaReal=allUsuarios[indexUsu].cedulaReal?allUsuarios[indexUsu].cedulaReal:''
    }
    if(args.realizado==='S' || args.realizado==='Si'){
      realizado='S'
    }else{
      realizado='N'
    }
      
    argsUpd['ruta'] = args.ruta
    argsUpd['numeroOrden'] = args.numeroOrden
    argsUpd['tipoAct'] = 'EditarEjec'
    argsUpd['fechaUpd'] = fechaHoraHoy
    argsUpd['usuarioUpd'] = localStorage.getItem('userLogin')
    argsUpd['realizado'] = realizado
    argsUpd['observacionesReal'] = args.observacionesReal?args.observacionesReal:''
    argsUpd['imgAntes'] = args.imgAntes
    argsUpd['imgDespues'] = args.imgDespues
    argsUpd['alimSistema'] = 'S'
    if(realizado==='S'){
      argsUpd['fechaReal'] = fechaReal
      argsUpd['horaReal'] = horaReal
      argsUpd['cedulaReal'] = cedulaReal
      argsUpd['minutosReal'] = args.minutosReal
      argsUpd['cantidadReal'] = args.cantidadReal 
      argsUpd['nombreUsuarioReal'] = nombreUsuarioReal
    }else{
      argsUpd['horaReal'] = 0
      argsUpd['cedulaReal'] = ''
      argsUpd['minutosReal'] = 0
      argsUpd['cantidadReal'] = 0 
      argsUpd['nombreUsuarioReal'] = ''
    }
  console.log(argsUpd)

    if(2>1){
      const response = await this.props.editOrden({
        variables: argsUpd
      });
      const {errors, success} = response.data.editOrden;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        if(args.imgAntes!==null && args.imgAntes!==''){
          argsUpd = {
            "tipoAct": 'EditarImgAntes',
            "imgAntes": args.imgAntes,
            "numeroOrden": args.numeroOrden,
            "ruta": args.ruta
          }
          if(!args.file){
          }else{
            let response = await this.props.singleUpload({variables: {file: args.file}}); 
          }
          let response = await this.props.editOrden({
            variables: argsUpd
          });
          const {errors, success} = response.data.editOrden;
        }
        if(args.imgDespues!==null && args.imgDespues!==''){
          argsUpd = {
            "tipoAct": 'EditarImgDespues',
            "imgDespues": args.imgDespues,
            "numeroOrden": args.numeroOrden,
            "ruta": args.ruta
          }
          if(!args.file1){
          }else{
            let response = await this.props.singleUpload({variables: {file: args.file1}}); 
          }
          let response = await this.props.editOrden({
            variables: argsUpd
          });
          const {errors, success} = response.data.editOrden;
        }
        await this.props.allOrdenRtes1.refetch()

        this.estadosFalse()
        this.setState({showRepProgInd: true})
      }
    }
  }
}

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false, permiteClose: false})
  }
  handleSelFrecuencia = () => {
    var miLista = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrFrecuencia'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }  
  handleSelFrecuenciaPre = () => {
    var miLista = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['descrFrecuenciaPre'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }    

  handleSelHallazgo = () => {
    var miLista = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['descrHallazgo'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }
  handleSelTarea = () => {
    var miLista = document.getElementById("miLista7");
    const argsAdd = this.state.argsAdd
    argsAdd['descrTarea'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }
  handleSelModo = () => {
    var miLista = document.getElementById("miLista8");
    const argsAdd = this.state.argsAdd
    argsAdd['modoTarea'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }
  handleSelSISO = () => {
    var miLista = document.getElementById("miLista10");
    const argsAdd = this.state.argsAdd
    argsAdd['requiereSISO'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }  
  handleSelPlanta = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['descrPlanta'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codPlanta'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 
  handleSelSeccion = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['descrSeccion'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codSeccion'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 
  handleSelEquipo = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEquipo'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codEquipo'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['nombreUsuario'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['cedula'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['acumulado'] = miLista.options[miLista.selectedIndex].attributes[3].value
    argsAdd['descrPrograma'] = miLista.options[miLista.selectedIndex].attributes[4].value
    this.setState({argsAdd});
  } 
  handleSelComponente = () => {
    var miLista = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrComponente'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codComponente'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 
  handleSelMecanismo = () => {
    var miLista = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['descrMecanismo'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codMecanismo'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['codigoQR'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['claseLub'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['descrAplicacion'] = miLista.options[miLista.selectedIndex].attributes[3].value
    argsAdd['descrFabricante'] = miLista.options[miLista.selectedIndex].attributes[4].value
    argsAdd['descrLubricante'] = miLista.options[miLista.selectedIndex].attributes[5].value
    argsAdd['categoriaLub'] = miLista.options[miLista.selectedIndex].attributes[6].value
    argsAdd['tipoLub'] = miLista.options[miLista.selectedIndex].attributes[7].value
    argsAdd['tipoFrecuencia'] = miLista.options[miLista.selectedIndex].attributes[8].value
    argsAdd['abrevUnidadTF'] = miLista.options[miLista.selectedIndex].attributes[9].value
    argsAdd['cantidadTotal'] = miLista.options[miLista.selectedIndex].attributes[10].value
    argsAdd['descrUnidad'] = miLista.options[miLista.selectedIndex].attributes[11].value
    argsAdd['abrevUnidad'] = miLista.options[miLista.selectedIndex].attributes[12].value
    this.setState({argsAdd});
  }
  
  handleSelProcEjec = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreArchivo'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }
  
  handleSelUsuario = () => {
    var miLista = document.getElementById("miLista9");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreUsuario'] = miLista.options[miLista.selectedIndex].text
    argsAdd['mail'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['telefono'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['cedula'] = miLista.options[miLista.selectedIndex].attributes[2].value
    this.setState({argsAdd});
  }
  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: true, permiteClose: false})
  }

  handleClickClo = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: false, permiteClose: true})
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.showProg!==prevState.showProg&&prevState.showProg){
      let argsBuscProg = this.state.argsBuscProg
      argsBuscProg.descrEmpresa = localStorage.getItem('Empresa')==="Todas..."?"Seleccionar Empresa...":localStorage.getItem('Empresa')
      if(argsBuscProg.descrPlanta){
        delete argsBuscProg.descrPlanta
      }
      if(argsBuscProg.descrSeccion){
        delete argsBuscProg.descrSeccion
      }
      if(argsBuscProg.descrEquipo){
        delete argsBuscProg.descrEquipo
      }
    }
    if(this.state.argsBuscProg.descrEmpresa){
//Para actualizar los criterios de busqueda cuando se hace cambia de pantalla y regresa
      if(this.state.argsBuscProg.descrEmpresa){
        var descrEmpresa = document.getElementById("miLista");
        if(descrEmpresa){descrEmpresa.value = this.state.argsBuscProg.descrEmpresa}
      }

      if(this.state.argsBuscProg.numDocum){
        var numDocum = document.getElementById("numDocum");
        if(numDocum){numDocum.value = this.state.argsBuscProg.numDocum}
      }

      if(this.state.argsBuscProg.descrPlanta){
        var descrPlanta = document.getElementById("descrPlantaB");
        if(descrPlanta){descrPlanta.value = this.state.argsBuscProg.descrPlanta}
      }
      if(this.state.argsBuscProg.descrSeccion){
        var descrSeccion = document.getElementById("descrSeccionB");
        if(descrSeccion){descrSeccion.value = this.state.argsBuscProg.descrSeccion}
      }
      if(this.state.argsBuscProg.descrEquipo){
        var descrEquipo = document.getElementById("descrEquipoB");
        if(descrEquipo){descrEquipo.value = this.state.argsBuscProg.descrEquipo}
      }
      if(this.state.argsBuscProg.descrComponente){
        var descrComponente = document.getElementById("descrComponenteB");
        if(descrComponente){descrComponente.value = this.state.argsBuscProg.descrComponente}
      }
      if(this.state.argsBuscProg.descrMecanismo){
        var descrMecanismo = document.getElementById("descrMecanismoB");
        if(descrMecanismo){descrMecanismo.value = this.state.argsBuscProg.descrMecanismo}
      }
      if(this.state.argsBuscProg.estado){
        var estado = document.getElementById("estado");
        if(estado){estado.value = this.state.argsBuscProg.estado}
      }
      this.props.allPlantaRtes.refetch()
//FIN Para actualizar los criterios de busqueda cuando se hace cambia de pantalla y regresa
    }

    

    if((this.state.argsBuscProg!==prevState.argsBuscProg)||
        (this.props.allPlantaRtes.allPlantaRtes&&this.props.allPlantaRtes.allPlantaRtes.length===0)){
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsBuscProg.descrEmpresa}'`
      if(this.state.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.state.argsBuscProg.descrPlanta}/i`
      }
      if(this.state.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.state.argsBuscProg.descrSeccion}/i`
      }
      if(this.state.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.state.argsBuscProg.descrEquipo}/i`
      }
      if(this.state.argsBuscProg.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.state.argsBuscProg.descrComponente}/i`
      }
      if(this.state.argsBuscProg.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.state.argsBuscProg.descrMecanismo}/i`
      }
      if(this.state.argsBuscProg.estado){
        if(this.state.argsBuscProg.estado==='VIGENTE'){
          argsBuscar += `, 'numCarta': {$lt: 0}`
        }
        if(this.state.argsBuscProg.estado==='PROGRAMADO'){
          argsBuscar += `, 'enRuta': 'S', 'numCarta': {$gte: 0}`
        }
        if(this.state.argsBuscProg.estado==='VENCIDO'){
          argsBuscar += `, 'enRuta': 'N', 'numCarta': {$gte: 0}`
        }      
      }
      let argsBuscarPl = {}
      let argsQuery = this.state.argsQuery1

      if(this.state.argsBuscProg.numDocum){
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}, {$limit: ${this.state.argsBuscProg.numDocum}}]`}
      }else{
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
      }
      console.log(argsBuscarPl)
      this.props.allPlantaRtes.refetch(argsBuscarPl)
    }
  }

  render(){
    const {showProg, showGenProg, showExcel, showProyec, showGenProgDia, showRepProg, verProgRep, showRepProgInd, showRepProgCerr, 
      showInfProg, showDepurar, showBitacora, showBitacoraTurno, opcion, showUpdProg, verProgramacion, showTableroProg, showTableroBita, 
          permiteUpdate, permiteDelete, permiteClose, showAddProg, argsUpd, showBuscProg, showOtHallazgo, addOtHallazgo, verOtHallazgo,
          argsAdd, errorAdd, argsBuscar, argsBuscProg, argsBuscInf, argsBuscPruebaLab, idLista, idListaAp, ruta} = this.state;
    // console.log(this.props.autorizacUA)

      let lista = []
      let lista1 = []
      let lista10 = []
      let lista11 = []
      let lista12 = []
      let lista13 = []
      let descrEmpresaUA=localStorage.getItem('Empresa')
      if (this.state.showExcel) {
        if(this.props.allOrdenRtes.allOrdenRtes){lista = this.props.allOrdenRtes.allOrdenRtes}
      }
      if (this.state.showProyec) {
        if(this.props.allOrdenRtes.allOrdenRtes){lista = this.props.allOrdenRtes.allOrdenRtes}
      }      
      if (this.state.showGenProg) {
        if(this.props.allOrdenRtes.allOrdenRtes){lista = this.props.allOrdenRtes.allOrdenRtes}
      }
      if (this.state.showGenProgDia) {
        if(this.props.allOrdenRtes.allOrdenRtes){lista = this.props.allOrdenRtes.allOrdenRtes}
      }
      if (this.state.showRepProg || this.state.showRepProgCerr) {
        if(this.props.allOrdenRtes.allOrdenRtes){lista = this.props.allOrdenRtes.allOrdenRtes}
      }
      if (this.state.showRepProgInd) {
        console.log(this.props.allOrdenRtes1.allOrdenRtes)
        if(this.props.allOrdenRtes1.allOrdenRtes){lista = this.props.allOrdenRtes1.allOrdenRtes}
        console.log(lista)
      }     
      if (this.state.showInfProg) {
        lista1.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
        if(descrEmpresaUA==="Todas..."){
          if(this.props.allEmpresa.allEmpresa){
            this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
              if(elemento.rutas==='S'){
                lista1.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
              }
            })
          }
        }else{
          lista1.push({descrEmpresa: descrEmpresaUA, _id: 1})
        }
        if(this.props.allOrdenRtes.allOrdenRtes){lista = this.props.allOrdenRtes.allOrdenRtes}
      }
      if (this.state.showOtHallazgo) {
        if(this.props.allOrdenRtes.allOrdenRtes){lista = this.props.allOrdenRtes.allOrdenRtes}
      }
      if (this.state.addOtHallazgo) {
        lista1.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
        if(descrEmpresaUA==="Todas..."){
          if(this.props.allEmpresa.allEmpresa){
            this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
              if(elemento.rutas==='S'){
                lista1.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
              }            })
          }
        }else{
          lista1.push({descrEmpresa: descrEmpresaUA, _id: 1})
        }
        if(this.props.allHallazgo.allHallazgo){lista = this.props.allHallazgo.allHallazgo}
        if(this.props.allTarea.allTarea){lista10 = this.props.allTarea.allTarea}
      }
      if (this.state.verProgramacion) {
        if(this.props.allMetodo.allMetodo){lista = this.props.allMetodo.allMetodo}
        if(this.props.allTarea.allTarea){lista10 = this.props.allTarea.allTarea}
        if(this.props.allProcEjec.allProcEjec){lista11 = this.props.allProcEjec.allProcEjec}
        if(this.props.allFrecuencia.allFrecuencia){lista12 = this.props.allFrecuencia.allFrecuencia}
        if(this.props.allFrecuencia2.allFrecuencia){lista13 = this.props.allFrecuencia2.allFrecuencia}
      }
      if (this.state.verProgRep) {
        // if(this.props.allMetodo.allMetodo){lista = this.props.allMetodo.allMetodo}
        // if(this.props.allTarea.allTarea){lista10 = this.props.allTarea.allTarea}
        // if(this.props.allProcEjec.allProcEjec){lista11 = this.props.allProcEjec.allProcEjec}
        // if(this.props.allFrecuencia.allFrecuencia){lista12 = this.props.allFrecuencia.allFrecuencia}
        // if(this.props.allFrecuencia2.allFrecuencia){lista13 = this.props.allFrecuencia2.allFrecuencia}
      }
      if (this.state.showProg) {
        console.log(this.props.allPlantaRtes.allPlantaRtes)
        if(this.props.allPlantaRtes.allPlantaRtes){lista = this.props.allPlantaRtes.allPlantaRtes}
        console.log(lista)
        lista1.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
        if(descrEmpresaUA==="Todas..."){
          if(this.props.allEmpresa.allEmpresa){
            this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
              if(elemento.rutas==='S'){
                lista1.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
              }            
            })
          }
        }else{
          lista1.push({descrEmpresa: descrEmpresaUA, _id: 1})
        }
        // console.log(lista1)
      }

      let fechaHoy = new Date()

      fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

      //calcular fechaFin como 6 dias despues de la feccha actual
      let fechaFin = parseInt((new Date().getTime() + (1000*60*60*24)*6), 10)
      fechaFin = new Date(fechaFin)
      fechaFin = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
      
      let fechaFin2 = new Date()
      fechaFin2 = (fechaFin2.getFullYear()) + '-' + ((fechaFin2.getMonth()+1)<10?'0'+(fechaFin2.getMonth()+1):(fechaFin2.getMonth()+1)) + '-' + (fechaFin2.getUTCDate()<10?'0'+fechaFin2.getUTCDate():fechaFin2.getUTCDate())

      //calcular fechaHoy como 364 dias antes de la fecha actual
      let fechaHoy2 = parseInt((new Date().getTime() - (1000*60*60*24)*1), 10)
      fechaHoy2 = new Date(fechaHoy2)
      fechaHoy2 = (fechaHoy2.getFullYear()) + '-' + ((fechaHoy2.getMonth()+1)<10?'0'+(fechaHoy2.getMonth()+1):(fechaHoy2.getMonth()+1)) + '-' + (fechaHoy2.getUTCDate()<10?'0'+fechaHoy2.getUTCDate():fechaHoy2.getUTCDate())

      
      return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showProg && <HomeProg1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                        handleClickSel11={this.showGenProg} handleClickSel12={(ev)=>this.showRepProg(ev, ruta)} 
                        handleClickSel25={this.showRepProgCerr} 
                        handleClickSel13={this.showDescProg} handleClickSel14={this.showUpdProg}
                        handleClickSel15={this.showGenProgDia} handleClickSel16={this.showAddProg}
                        handleClickSel17={this.showInfProg} handleClickSel18={this.showExcel}
                        handleClickSel19={this.showBuscProg} handleClickSel20={this.showOtHallazgo}
                        handleClickSel21={this.showProyec} handleClickSel22={this.showDepurar}
                        handleClickSel23={this.showBitacora} handleClickSel24={this.showBitacoraTurno}
                        // handleClickSel24={this.showTableroProg} 
                        handleClickSel26={this.showRepProgInd}
                        args={argsBuscProg} handleSubmit={this.handleBuscProg} 
                        handleChange={this.handleChangeBuscProg}/>}   

            {verProgramacion && <VerProg1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                    handleClickRegr={this.showProg}
                    handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}
            {showExcel && <ProgExcel1 styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscar} handleClickRegr={this.showProg}/>}
            {showProyec && <ProgProyec1 styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscar} handleClickRegr={this.showProg}/>}    
            {showGenProg && <ProgGenProg1 styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscar} handleClickRegr={this.showProg}/>}
            {showGenProgDia && <ProgGenProgDia1 styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscar} handleClickRegr={this.showProg}/>}   

            {showOtHallazgo && <ProgOtHallazgo1 styles={this.props.styles} handleClickRegr={this.showProg}
                handleChange={this.handleChangeBuscProg} handleSubmit={this.handleBuscProg} args={argsBuscar}/>}
            {addOtHallazgo && <AddOtHallazgo1 styles={this.props.styles} handleClickRegr={this.showOtHallazgo}/>}
            {verOtHallazgo && <VerOtHallazgo1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showOtHallazgo} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
                         
            {showUpdProg && <CargProg1 styles={this.props.styles} handleClickRegr={this.showProg}/>}
            {showAddProg && <ProgAddProg1 styles={this.props.styles} handleClickRegr={this.showProg}/>}
            {showRepProg && <ProgRepProg1 styles={this.props.styles}
                handleChange={this.handleChangeBuscProg} handleSubmit={this.handleBuscProg}
                args={argsBuscar} handleClickRegr={this.showProg}/>}
            {showRepProgInd && <ProgRepProgInd1 styles={this.props.styles} args={argsBuscar} handleClickRegr={this.showProg}
                 handleChange={this.handleChangeBuscProg} handleSubmit={this.handleBuscProg}/>}
            {verProgRep && <VerProgRep1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                    handleClickRegr={this.showRepProgInd} handleClickUpd={this.handleClickUpd}/>}    
            {showRepProgCerr && <ProgRepProgCerr1 styles={this.props.styles} handleClickRegr={this.showProg}/>}
            {showInfProg && <ProgInfProg1 styles={this.props.styles}
                handleChange={this.handleChangeBuscProg} handleSubmit={this.handleBuscProg}
                args={argsBuscar} handleClickRegr={this.showProg}/>}          
            {showBuscProg && <ProgBuscProg1 styles={this.props.styles} handleClickRegr={this.showProg}
                handleChange={this.handleChangeBuscProg} handleSubmit={this.handleBuscProg}
                args={argsBuscar}/>}       
            {showDepurar && <ProgDepurar1 styles={this.props.styles} handleClickRegr={this.showProg}/>}
            {showBitacora && <ProgBitacoraNueva1 styles={this.props.styles} handleClickRegr={this.showProg}
                handleChange={this.handleChangeBuscProg} handleSubmit={this.handleBuscProg}
                args={argsBuscar}/>}
            {showBitacoraTurno && <ProgBitacoraTurno1 styles={this.props.styles} handleClickRegr={this.showProg}
                handleChange={this.handleChangeBuscProg} handleSubmit={this.handleBuscProg}
                args={argsBuscar}/>}
            {showTableroProg && <ProgTableroProg1 styles={this.props.styles} handleClickRegr={this.showProg}/>}
            {showTableroBita && <ProgTableroBita1 styles={this.props.styles} handleClickRegr={this.showProg}/>}
          </div>

          <div className="column" style={this.props.styles.boxDer}>
            {showProg && <HomeProg2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
              list={lista} list1={lista1} handleClickidLista={this.idLista}
              handleChange={this.handleChangeBuscProg} argsBuscProg={argsBuscProg}/>}

            {verProgramacion && <VerProg2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} list={lista} list1={lista1}
                    list10={lista10} list11={lista11} list12={lista12} list13={lista13} errors={errorAdd} 
                    handleSubmit={this.handleProg} args={argsAdd} idLista={idLista}
                    permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}
            {showOtHallazgo && <ProgOtHallazgo2 descrEmpresaUA={descrEmpresaUA} autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscProg={argsBuscProg} handleUpdAsImgOT={this.handleUpdAsImgOT}
                handleClick={this.addOtHallazgo} list={lista} handleClickidLista={this.idLista}/>} 
            {addOtHallazgo && <AddOtHallazgo2 styles={this.props.styles} handleSubmit={this.handleOtHallazgo} 
                handleLista={this.handleSelPlanta} handleLista1={this.handleSelSeccion}
                handleLista2={this.handleSelEquipo} handleLista3={this.handleSelComponente}
                handleLista4={this.handleSelMecanismo} handleLista5={this.handleSelHallazgo}
                handleLista6={this.handleSelTarea} handleLista7={this.handleSelModo} 
                handleLista8={this.handleSelUsuario} handleLista9={this.handleSelSISO}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} list={lista} list1={lista1} list10={lista10}/>}
            {verOtHallazgo && <VerOtHallazgo2 styles={this.props.styles} handleSubmit={this.handleOtHallazgo} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}
            {showExcel && <ProgExcel2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscProg={argsBuscProg} fechaFin={fechaFin} fechaHoy={fechaHoy} rutaLogo={this.props.rutaLogo}
                handleLista1={this.handleSeltipoVista} handleChange={this.handleChange} args={argsAdd}/>} 
            {showProyec && <ProgProyec2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscProg={argsBuscProg} fechaFin={fechaFin} fechaHoy={fechaHoy} 
                handleChange={this.handleChange}/>}
            {showGenProg && <ProgGenProg2 descrEmpresaUA={descrEmpresaUA} autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscProg={argsBuscProg} fechaFin={fechaFin} fechaHoy={fechaHoy}/>}
            {showGenProgDia && <ProgGenProgDia2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscProg={argsBuscProg}/>}            
            {showUpdProg && <CargProg2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} tipoCargue="Upd"/>}
            {showAddProg && <ProgAddProg2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} tipoCargue="Add"/>}
            {showRepProg && <ProgRepProg2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}  
                handleClickidLista={this.idLista} argsBuscProg={argsBuscProg}/>}
            {showRepProgInd && <ProgRepProgInd2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscProg={argsBuscProg} handleClickidLista={this.idLista} list={lista} handleClickRegr={this.showProg}/>}
            {verProgRep && <VerProgRep2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} errors={errorAdd} 
                handleSubmit={this.handleProgRep} args={argsAdd} idLista={idLista}
                permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}
            {showRepProgCerr && <ProgRepProgCerr2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showProg}/>}
            {showInfProg && <ProgInfProg2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} list1={lista1}
                argsBuscProg={argsBuscProg} fechaFin={fechaFin} fechaHoy={fechaHoy}/>} 
            {showBuscProg && <ProgBuscProg2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscProg={argsBuscProg} fechaFin={fechaFin2} fechaHoy={fechaHoy2}/>}   
            {showDepurar && <ProgDepurar2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}
            {showBitacora && <ProgBitacoraNueva2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscProg={argsBuscProg} fechaFin={fechaFin2} fechaHoy={fechaHoy2}/>}
            {showBitacoraTurno && <ProgBitacoraTurno2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscProg={argsBuscProg} fechaFin={fechaFin2} fechaHoy={fechaHoy2}/>}    
            {showTableroProg && <ProgTableroProg2 styles={this.props.styles}/>}
            {showTableroBita && <ProgTableroBita2 styles={this.props.styles}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose( 
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  // graphql(queries.query.allOrden, {name:'allOrden', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrMetodo: 'Hallazgo'}}, {$sort: {numeroOrden: -1}}]`}}}}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {estadoOrden: 'Abierto'}}, {$sort: {descrEmpresa: 1, ruta: 1, numeroOrden: 1}}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),    
  graphql(queries.query.allAutorizac, {name:'allAutorizac', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),

  graphql(queries.query.allMetodo, {name:'allMetodo'}),
  graphql(queries.query.allTarea, {name:'allTarea'}),
  graphql(queries.query.allProcEjec, {name:'allProcEjec'}),
  graphql(queries.query.allInfoTarea, {name:'allInfoTarea'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'tipoFrecuencia': 'Calendario', descrFrecuencia: $ne: "Predictiva"}}]`}}}}),
  graphql(queries.query.allHallazgo, {name:'allHallazgo'}),
  graphql(queries.mutation.editOrden, {name:'editOrden'}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Técnico', estado: 'Activo', perfil: {$in: ['Tribologos', 'Ingenieros y Coordinadores de lubricación']}}}]`}}}}),
  graphql(queries.mutation.encriptar, {name:'encriptar'}),
  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeProg)
